import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import Header from "./header/header";
import "./doyenaccess.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { z, ZodType } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import Select from "react-select";
import countryList from "react-select-country-list";
import Footer from "./Footer";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import { baseUrl, GetToken, getUserCountry } from "../App";

type FormData = {
  Name: string;
  Email: string;
  Degree?: string;
  FieldofStudy: string;
  TargetofMent?: string;
  Transition?: string;
  Goal: string;
  Request?: string;
  Phone?: any;
  Years?: number;
};

type PopupProps = {
  handleSubmit: (e: any) => void;
  values: { name: string; email: string; phone: string };
  errorMessage: string;
};

const Popup: React.FC<PopupProps> = ({
  handleSubmit,
  values,
  errorMessage,
}) => {
  const inputs = [
    {
      label: "Name",
      type: "text",
      name: "Name",
      placeholder: "Enter Name",
      value: values.name,
    },
    {
      label: "Email",
      type: "email",
      name: "Email",
      placeholder: "Enter Your Email Address",
      value: values.email,
    },
    {
      label: "Phone",
      type: "tel",
      name: "Phone",
      placeholder: "Enter Phone Number",
      value: values.phone,
    },
    {
      label: "Years of Experience",
      type: "number",
      name: "Years",
      placeholder: "Number of years",
    },
    {
      label: "Field",
      type: "text",
      name: "FieldofStudy",
      placeholder: "Enter Your Relative Field",
    },

    {
      label: "Goal",
      type: "text",
      name: "Goal",
      placeholder: "What do you intend to achieve",
    },
  ];

  return (
    <div className="popup">
      <div className="popup-inner">
        <form
          className=" flex flex-col items-center w-full"
          // onSubmit={formSubmit}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-3 w-full">
            {inputs.slice(0, 4).map((input, index) => (
              <div
                key={index}
                className="w-full md:flex md:flex-col sm:flex sm:flex-col  "
              >
                {/* textinputs */}
                <div className="xl:float-left lg:float-left mt-1">
                  <p>{input.label}</p>
                </div>
                <div className="w-full">
                  <input
                    type={input.type}
                    className="newtextinputs p-2 block sm:hidden md:hidden"
                    placeholder={input.placeholder}
                    name={input.name}
                    onChange={handleSubmit}
                    required
                    value={input.value}
                  ></input>
                  <input
                    type={input.type}
                    className="textarea p-2 xl:hidden lg:hidden sm:w-full md:w-full"
                    placeholder={input.placeholder}
                    name={input.name}
                    onChange={handleSubmit}
                    required
                    value={input.value}
                  ></input>
                </div>
              </div>
            ))}
          </div>

          <div className=" w-full xl:w-[95%] lg:w-[95%] xl:ml-[-2em] lg:ml-[-2em] flex flex-col">
            <div className="float-left mt-1">
              <p>{inputs[4].label}</p>
            </div>
            <div className=" w-full">
              <input
                type={inputs[4].type}
                className="textarea w-full p-2 block"
                placeholder={inputs[4].placeholder}
                name={inputs[4].name}
                onChange={handleSubmit}
                required
                value={inputs[4].value}
              ></input>
            </div>
          </div>

          <div className=" w-full xl:w-[95%] lg:w-[95%] xl:ml-[-2em] lg:ml-[-2em]  flex flex-col">
            <div className="float-left mt-1">
              <p>{inputs[5].label}</p>
            </div>
            <div className="w-full">
              <textarea
                name={inputs[5].name}
                id=""
                cols={30}
                rows={5}
                className="textarea block w-full p-2"
                onChange={handleSubmit}
                value={inputs[5].value}
              ></textarea>
            </div>
          </div>
        </form>
        {errorMessage && (
          <p className="text-red-500 text-sm mt-1 errorMessage">
            {errorMessage}
          </p>
        )}
      </div>
    </div>
  );
};

const DoyenaccessDetails: React.FC = () => {
  const [ready, setReady] = useState(false);
  const [inputName, setInputName] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [inputPhone, setInputPhone] = useState("");
  const [inputDegree, setInputDegree] = useState("");
  const [inputNyscCN, setInputNyscCN] = useState("");
  const [inputYearsofExp, setInputYearsofExp] = useState("");
  const [inputFieldofStudy, setInputFieldofStudy] = useState("");
  const [inputCountry, setInputCountry] = useState("");
  const [inputTargetofMent, setInputTargetofMent] = useState("");
  const [inputTransition, setInputTransition] = useState("");
  const [inputCommunication, setInputCommunication] = useState("");
  const [inputFrequency, setInputFrequency] = useState("");
  const [inputGoal, setInputGoal] = useState("");
  const [inputRequest, setInputRequest] = useState("");
  const [inputMedium, setInputMedium] = useState("");
  const [inputComment, setInputComment] = useState("");
  const [nophoneerror, setNophoneerror] = useState(true);
  const [valueCountry, setValueCountry] = useState("");
  const [errorYearsofExp, setErrorYearsofExp] = useState(false);
  const [errorCommunication, setErrorCommunication] = useState(false);
  const [errorFrequency, setErrorFrequency] = useState(false);
  const [errorMedium, setErrorMedium] = useState(false);
  const [errorCountry, setErrorCountry] = useState(false);
  const [showNysc, setShowNysc] = useState(false);
  const [showPaybuttons, setShowPaybuttons] = useState(false);
  const [showOthers, setShowOthers] = useState(true);
  const [pakagename, setPakagename] = useState("");
  const displayDatalive = useRef(true);
  const options = useMemo<any>(() => countryList().getData(), []);
  const [authUser, setAuthUser] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    Name: "",
    Email: "",
    Phone: "",
    FieldofStudy: "",
    Years: 0,
    Goal: "",
  });
  const [data, setData] = useState<any>({});
  const [prices, setPrices] = useState({
    Basic: 0,
    Intermediate: 0,
    Professional: 0,
  });
  const [currency, setCurrency] = useState("$");
  const [errorMessage, setErrorMessage] = useState("");

  let params: any = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        setAuthUser(false);
        navigate("/signin", { state: { from: location.pathname } });
        return;
      } else {
        if (localStorage.getItem("doyenifyacademytwitterUid")) {
          setAuthUser(true);
        } else if (user?.emailVerified === true) {
          setAuthUser(true);
        } else {
          setAuthUser(false);
          navigate("/signin", { state: { from: location.pathname } });
        }
        let idToken = GetToken();
        axios
          .get(`${baseUrl}/registration`, {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          })
          .then((responseprofile) => {
            const dataprofile = responseprofile.data;

            for (const [__, valueprofile] of Object.entries(dataprofile)) {
              const value1profile: any = valueprofile; // Safely assign the value to a constant
              console.log(__);

              if (value1profile.email === user.email) {
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  Name: value1profile.firstname
                    ? `${value1profile.firstname} ${value1profile.lastname}`
                    : "",
                  Email: user.email ? user.email : "",
                  Phone: value1profile.phone ? value1profile.phone : "",
                }));
              }
            }
          })
          .catch((error) => {
            console.error("Error fetching profile data:", error);
          });
      }
    });
  }, [authUser, navigate, location.pathname]);

  useEffect(() => {
    setShowPaybuttons(true);
  }, []);

  useEffect(() => {
    if (params["ids"] === "basicaccess") {
      setPakagename("Basic Access");
    } else if (params["ids"] === "intermediateaccess") {
      setPakagename("Intermediate Access");
    } else if (params["ids"] === "professionalaccess") {
      setPakagename("Professional Access");
    }

    async function getAccess() {
      const userDetails = await getUserCountry();
      let accessPrices: any[] = [];

      try {
        let idToken = await GetToken();
        const res = await axios.get(`${baseUrl}/accessprice`, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        });

        accessPrices = await res.data;
        setReady(true);
      } catch (error) {
        console.log(error);
      }

      switch (userDetails.continentCode) {
        case "EU":
          setCurrency("€");
          setPrices({
            ...prices,
            Basic: accessPrices[0].Price.priceInEuros,
            Intermediate: accessPrices[1].Price.priceInEuros,
            Professional: accessPrices[2].Price.priceInEuros,
          });

          break;
        case "AF":
          if (userDetails.countryCode === "NG") {
            setCurrency("NGN");
            setPrices({
              ...prices,
              Basic: accessPrices[0].Price.priceInNaira,
              Intermediate: accessPrices[1].Price.priceInNaira,
              Professional: accessPrices[2].Price.priceInNaira,
            });
          } else {
            setCurrency("$");
            setPrices({
              ...prices,
              Basic: accessPrices[0].Price.priceForOtherAfricans,
              Intermediate: accessPrices[1].Price.priceForOtherAfricans,
              Professional: accessPrices[2].Price.priceForOtherAfricans,
            });
          }

          break;
        default:
          setCurrency("$");
          setPrices({
            ...prices,
            Basic: accessPrices[0].Price.priceInDollars,
            Intermediate: accessPrices[1].Price.priceInDollars,
            Professional: accessPrices[2].Price.priceInDollars,
          });
          break;
      }
    }

    getAccess();
  }, [params, prices]);

  const subscribeNysc = () => {
    setShowNysc(!showNysc);
  };

  const changeHandler = (value: any) => {
    setValueCountry(value);
    setInputCountry(value["label"]);
  };

  const makepayment = async () => {
    if (Object.values(formData).every((value) => value.length !== 0)) {
      const stripe: any = await loadStripe(
        String(process.env.REACT_APP_STRIPEPK_LIVEKEY)
      );
      var body: any;
      if (params["ids"] === "basicaccess") {
        body = {
          packages: [
            {
              program: "doyenaccess",
              name: params["ids"],
              price: "110",
              image:
                "https://st.depositphotos.com/2890953/4530/i/950/depositphotos_45303419-stock-photo-books-and-graduation-cap.jpg",
              currency: "eur",
            },
          ],
          successUrl: process.env.REACT_APP_API_STRIPE_DOYENACCESSSUCCESS_URL,
          cancelUrl: process.env.REACT_APP_API_STRIPE_DOYENACCESSFAILURE_URL,
        };
        //"http://localhost:3000/doyenaccesssuccess"
        //"http://localhost:3000/doyenaccesscancel"
      } else if (params["ids"] === "intermediateaccess") {
        body = {
          packages: [
            {
              program: "doyenaccess",
              name: params["ids"],
              price: "180",
              image:
                "https://st.depositphotos.com/2890953/4530/i/950/depositphotos_45303419-stock-photo-books-and-graduation-cap.jpg",
              currency: "eur",
            },
          ],
          successUrl: process.env.REACT_APP_API_STRIPE_DOYENACCESSSUCCESS_URL,
          cancelUrl: process.env.REACT_APP_API_STRIPE_DOYENACCESSFAILURE_URL,
        };
      } else if (params["ids"] === "professionalaccess") {
        body = {
          packages: [
            {
              program: "doyenaccess",
              name: params["ids"],
              price: "250",
              image:
                "https://st.depositphotos.com/2890953/4530/i/950/depositphotos_45303419-stock-photo-books-and-graduation-cap.jpg",
              currency: "eur",
            },
          ],
          successUrl: process.env.REACT_APP_API_STRIPE_DOYENACCESSSUCCESS_URL,
          cancelUrl: process.env.REACT_APP_API_STRIPE_DOYENACCESSFAILURE_URL,
        };
      }

      const headers = {
        "Content-Type": "application/json",
      };

      const response = await fetch(`${baseUrl}/create-checkout-session`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body),
      });

      const session = await response.json();

      //
      accessFormSubmit();

      const result = stripe.redirectToCheckout({
        sessionId: session.id,
      });

      localStorage.setItem("sessiontrackidss", session.id);

      if (result.error) {
        console.log(result.error);
      }

      localStorage.setItem("installmentpresent", "false");
    } else {
      toast("Please fill the form to continue to payment.");
    }
  };

  const nameRegex = /^[A-Za-z\s]+$/;
  const schema: ZodType<FormData> = z.object({
    Name: z.string().min(2).max(30).regex(nameRegex, {
      message: "Name must only contain alphabetic characters",
    }),
    Email: z.string().email(),
    Degree: z.string().min(2).max(40),
    FieldofStudy: z.string().min(2).max(40),
    TargetofMent: z.string().min(2).max(40),
    Transition: z.string().min(2).max(40),
    Goal: z.string().min(2).max(40),
    Request: z.string().min(2).max(50),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({ resolver: zodResolver(schema) });

  const submitWebinarform = async (data: FormData) => {
    if (
      inputYearsofExp.length > 0 &&
      inputCommunication.length > 0 &&
      inputFrequency.length > 0 &&
      inputMedium.length > 0 &&
      inputCountry.length > 0 &&
      inputPhone.length > 6
    ) {
      setErrorYearsofExp(false);
      setErrorCommunication(false);
      setErrorFrequency(false);
      setErrorMedium(false);
      setErrorCountry(false);
      setNophoneerror(true);

      if (inputNyscCN.length > 0) {
      }
      if (inputComment.length > 0) {
      }

      if (params["ids"] === "basicaccess") {
        localStorage.setItem(
          "doyen-access-dataform",
          JSON.stringify({
            Name: inputName.trim(),
            Email: inputEmail.trim(),
            Phone: inputPhone.trim(),
            Degree: inputDegree.trim(),
            NyscCN: inputNyscCN.trim(),
            YearsofExp: inputYearsofExp.trim(),
            FieldofStudy: inputFieldofStudy.trim(),
            Country: inputCountry.trim(),
            TargetofMent: inputTargetofMent.trim(),
            Transition: inputTransition.trim(),
            Communication: inputCommunication.trim(),
            Frequency: inputFrequency.trim(),
            Goal: inputGoal.trim(),
            Request: inputRequest.trim(),
            Medium: inputMedium.trim(),
            Comment: inputComment.trim(),
            product: params["ids"],
            price: "110",
          })
        );
      } else if (params["ids"] === "intermediateaccess") {
        localStorage.setItem(
          "doyen-access-dataform",
          JSON.stringify({
            Name: inputName.trim(),
            Email: inputEmail.trim(),
            Phone: inputPhone.trim(),
            Degree: inputDegree.trim(),
            NyscCN: inputNyscCN.trim(),
            YearsofExp: inputYearsofExp.trim(),
            FieldofStudy: inputFieldofStudy.trim(),
            Country: inputCountry.trim(),
            TargetofMent: inputTargetofMent.trim(),
            Transition: inputTransition.trim(),
            Communication: inputCommunication.trim(),
            Frequency: inputFrequency.trim(),
            Goal: inputGoal.trim(),
            Request: inputRequest.trim(),
            Medium: inputMedium.trim(),
            Comment: inputComment.trim(),
            product: params["ids"],
            price: "180",
          })
        );
      } else if (params["ids"] === "professionalaccess") {
        localStorage.setItem(
          "doyen-access-dataform",
          JSON.stringify({
            Name: inputName.trim(),
            Email: inputEmail.trim(),
            Phone: inputPhone.trim(),
            Degree: inputDegree.trim(),
            NyscCN: inputNyscCN.trim(),
            YearsofExp: inputYearsofExp.trim(),
            FieldofStudy: inputFieldofStudy.trim(),
            Country: inputCountry.trim(),
            TargetofMent: inputTargetofMent.trim(),
            Transition: inputTransition.trim(),
            Communication: inputCommunication.trim(),
            Frequency: inputFrequency.trim(),
            Goal: inputGoal.trim(),
            Request: inputRequest.trim(),
            Medium: inputMedium.trim(),
            Comment: inputComment.trim(),
            product: params["ids"],
            price: "250",
          })
        );
      }

      setShowPaybuttons(true);
    } else {
      if (inputYearsofExp.length <= 0) {
        setErrorYearsofExp(true);
      } else {
        setErrorYearsofExp(false);
      }

      if (inputCommunication.length <= 0) {
        setErrorCommunication(true);
      } else {
        setErrorCommunication(false);
      }

      if (inputFrequency.length <= 0) {
        setErrorFrequency(true);
      } else {
        setErrorFrequency(false);
      }

      if (inputMedium.length <= 0) {
        setErrorMedium(true);
      } else {
        setErrorMedium(false);
      }

      if (valueCountry.length <= 0) {
        setErrorCountry(true);
      } else {
        setErrorCountry(false);
      }

      if (inputPhone.length < 6) {
        setNophoneerror(false);
      } else {
        setNophoneerror(true);
      }
    }
  };

  const loadingcontent = useCallback(async () => {
    let idToken = await GetToken();
    if (localStorage.getItem("doyenifyacademytwitter")) {
      await axios
        .get(`${baseUrl}/registration`, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        })
        .then((responseprofile) => {
          var emaildata = "";
          var dataprofile = responseprofile.data;
          var containerpresent: any = [];

          for (const [keyprofile, valueprofile] of Object.entries(
            dataprofile
          )) {
            var value1profile: any;
            value1profile = keyprofile;
            value1profile = valueprofile;
            if (
              value1profile["uids"] ===
              String(localStorage.getItem("doyenifyacademytwitterUid"))
            ) {
              emaildata = value1profile["email"];
              if (params["ids"] === "basicaccess") {
                localStorage.setItem(
                  "doyen-access-dataform",
                  JSON.stringify({
                    Name: value1profile["firstname"],
                    Email: value1profile["email"],
                    Phone: value1profile["phone"],
                    Degree: "",
                    NyscCN: "",
                    YearsofExp: "",
                    FieldofStudy: "",
                    Country: "",
                    TargetofMent: "",
                    Transition: "",
                    Communication: "",
                    Frequency: "",
                    Goal: "",
                    Request: "",
                    Medium: value1profile["sourceOfDiscovery"],
                    Comment: "",
                    product: params["ids"],
                    price: "110",
                  })
                );
              } else if (params["ids"] === "intermediateaccess") {
                localStorage.setItem(
                  "doyen-access-dataform",
                  JSON.stringify({
                    Name: value1profile["firstname"],
                    Email: value1profile["email"],
                    Phone: value1profile["phone"],
                    Degree: "",
                    NyscCN: "",
                    YearsofExp: "",
                    FieldofStudy: "",
                    Country: "",
                    TargetofMent: "",
                    Transition: "",
                    Communication: "",
                    Frequency: "",
                    Goal: "",
                    Request: "",
                    Medium: value1profile["sourceOfDiscovery"],
                    Comment: "",
                    product: params["ids"],
                    price: "180",
                  })
                );
              } else if (params["ids"] === "professionalaccess") {
                localStorage.setItem(
                  "doyen-access-dataform",
                  JSON.stringify({
                    Name: value1profile["firstname"],
                    Email: value1profile["email"],
                    Phone: value1profile["phone"],
                    Degree: "",
                    NyscCN: "",
                    YearsofExp: "",
                    FieldofStudy: "",
                    Country: "",
                    TargetofMent: "",
                    Transition: "",
                    Communication: "",
                    Frequency: "",
                    Goal: "",
                    Request: "",
                    Medium: value1profile["sourceOfDiscovery"],
                    Comment: "",
                    product: params["ids"],
                    price: "250",
                  })
                );
              }
            }
          }
          let idToken = GetToken();
          axios
            .get(`${baseUrl}/accessdoyen`, {
              headers: {
                Authorization: `Bearer ${idToken}`,
              },
            })
            .then((response2) => {
              var data232 = response2.data;

              for (const [key02, value02] of Object.entries(data232)) {
                var value101: any;
                value101 = key02;
                value101 = value02;

                if (
                  value101["trackemail"] === emaildata &&
                  value101["typepay"] === "installment" &&
                  value101["typepaystage"] === "first" &&
                  value101["product"] === params["ids"]
                ) {
                  localStorage.setItem("doyenaccesid", value101["id"]);
                  containerpresent.push("present");
                }

                if (
                  value101["trackemail"] === emaildata &&
                  value101["typepay"] === "installment" &&
                  value101["typepaystage"] === "second" &&
                  value101["product"] === params["ids"]
                ) {
                  navigate("/doyenaccess");
                }
              }

              if (containerpresent.includes("present")) {
                setShowOthers(false);
                setShowPaybuttons(true);
                if (params["ids"] === "basicaccess") {
                  localStorage.setItem("priceaccess", "110");
                } else if (params["ids"] === "intermediateaccess") {
                  localStorage.setItem("priceaccess", "180");
                } else if (params["ids"] === "professionalaccess") {
                  localStorage.setItem("priceaccess", "250");
                }
              }

              if (!containerpresent.includes("present")) {
                if (params["ids"] === "basicaccess") {
                  localStorage.setItem("priceaccess", "110");
                } else if (params["ids"] === "intermediateaccess") {
                  localStorage.setItem("priceaccess", "180");
                } else if (params["ids"] === "professionalaccess") {
                  localStorage.setItem("priceaccess", "250");
                }
              }
            });
        });
    } else {
      onAuthStateChanged(auth, (user: any) => {
        if (user) {
          axios
            .get(`${baseUrl}/registration`, {
              headers: {
                Authorization: `Bearer ${idToken}`,
              },
            })
            .then((responseprofile) => {
              var dataprofile = responseprofile.data;

              for (const [keyprofile, valueprofile] of Object.entries(
                dataprofile
              )) {
                var value1profile: any;
                value1profile = keyprofile;
                value1profile = valueprofile;
                if (value1profile["email"] === user.email) {
                  if (params["ids"] === "basicaccess") {
                    localStorage.setItem(
                      "doyen-access-dataform",
                      JSON.stringify({
                        Name: value1profile["firstname"],
                        Email: value1profile["email"],
                        Phone: value1profile["phone"],
                        Degree: "",
                        NyscCN: "",
                        YearsofExp: "",
                        FieldofStudy: "",
                        Country: "",
                        TargetofMent: "",
                        Transition: "",
                        Communication: "",
                        Frequency: "",
                        Goal: "",
                        Request: "",
                        Medium: value1profile["sourceOfDiscovery"],
                        Comment: "",
                        product: params["ids"],
                        price: "110",
                      })
                    );
                  } else if (params["ids"] === "intermediateaccess") {
                    localStorage.setItem(
                      "doyen-access-dataform",
                      JSON.stringify({
                        Name: value1profile["firstname"],
                        Email: value1profile["email"],
                        Phone: value1profile["phone"],
                        Degree: "",
                        NyscCN: "",
                        YearsofExp: "",
                        FieldofStudy: "",
                        Country: "",
                        TargetofMent: "",
                        Transition: "",
                        Communication: "",
                        Frequency: "",
                        Goal: "",
                        Request: "",
                        Medium: value1profile["sourceOfDiscovery"],
                        Comment: "",
                        product: params["ids"],
                        price: "180",
                      })
                    );
                  } else if (params["ids"] === "professionalaccess") {
                    localStorage.setItem(
                      "doyen-access-dataform",
                      JSON.stringify({
                        Name: value1profile["firstname"],
                        Email: value1profile["email"],
                        Phone: value1profile["phone"],
                        Degree: "",
                        NyscCN: "",
                        YearsofExp: "",
                        FieldofStudy: "",
                        Country: "",
                        TargetofMent: "",
                        Transition: "",
                        Communication: "",
                        Frequency: "",
                        Goal: "",
                        Request: "",
                        Medium: value1profile["sourceOfDiscovery"],
                        Comment: "",
                        product: params["ids"],
                        price: "250",
                      })
                    );
                  }
                }
              }
            });
          axios
            .get(`${baseUrl}/accessdoyen`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                  "AcademyidTokenlive22"
                )}`,
              },
            })
            .then((response2) => {
              var data232 = response2.data;
              var containerpresent: any = [];

              for (const [key02, value02] of Object.entries(data232)) {
                var value101: any;
                value101 = key02;
                value101 = value02;

                if (
                  value101["trackemail"] === user.email &&
                  value101["typepay"] === "installment" &&
                  value101["typepaystage"] === "first" &&
                  value101["product"] === params["ids"]
                ) {
                  localStorage.setItem("doyenaccesid", value101["id"]);
                  containerpresent.push("present");
                }

                if (
                  value101["trackemail"] === user.email &&
                  value101["typepay"] === "installment" &&
                  value101["typepaystage"] === "second" &&
                  value101["product"] === params["ids"]
                ) {
                  navigate("/doyenaccess");
                }
              }

              if (containerpresent.includes("present")) {
                setShowOthers(false);
                setShowPaybuttons(true);
                if (params["ids"] === "basicaccess") {
                  localStorage.setItem("priceaccess", "110");
                } else if (params["ids"] === "intermediateaccess") {
                  localStorage.setItem("priceaccess", "180");
                } else if (params["ids"] === "professionalaccess") {
                  localStorage.setItem("priceaccess", "250");
                }
              }

              if (!containerpresent.includes("present")) {
                if (params["ids"] === "basicaccess") {
                  localStorage.setItem("priceaccess", "110");
                } else if (params["ids"] === "intermediateaccess") {
                  localStorage.setItem("priceaccess", "180");
                } else if (params["ids"] === "professionalaccess") {
                  localStorage.setItem("priceaccess", "250");
                }
              }
            });
        } else {
          navigate("/doyenaccess");
        }
      });
    }
  }, [params, navigate]);

  useEffect(() => {
    var startTime = new Date().getTime();
    var interval = setInterval(async function () {
      if (new Date().getTime() - startTime > 120000) {
        clearInterval(interval);
        return;
      }
      if (
        displayDatalive.current === true &&
        localStorage.getItem("AcademyidTokenlive22")
      ) {
        loadingcontent();
        displayDatalive.current = false;
      }
    }, 20000);

    return () => {
      clearInterval(interval);
    };
  }, [loadingcontent]);

  const loadings = () => {
    new Promise((r) => setTimeout(r, 205));
  };

  useEffect(() => {
    loadings();
  }, []);

  async function handleAccessFormSubmit(event: any) {
    if (event.target.name === "Years") {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
    }

    if (event.target.name === "Phone") {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
    }

    if (event.target.name === "Name") {
      event.target.value = event.target.value.replace(/[^a-zA-Z]/g, "");
    }

    if (event.target.name === "FieldofStudy") {
      event.target.value = event.target.value.replace(/[^a-zA-Z]/g, "");
    }

    if (event.target.name === "Email") {
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9@._-]/g, "");
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(event.target.value)) {
        setErrorMessage("Please enter a valid email address.");
      } else {
        setErrorMessage("");
      }
    }

    const { name, value } = event.target;

    setFormData({ ...formData, [name]: value });

    const packageAmount =
      params["ids"] === "basicaccess"
        ? 110
        : params["ids"] === "intermediateaccess"
        ? 180
        : params["ids"] === "professionalaccess"
        ? 250
        : "";

    setData({
      ...formData,
      createdAt: new Date(),
      AmountPaid: packageAmount,
      PackagePaidFor: pakagename,
      PaymentCurrency: "€",
    });

    // accessdoyen
  }

  async function accessFormSubmit() {
    try {
      await axios.post(`${baseUrl}/accessdoyen`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "AcademyidTokenlive22"
          )}`,
        },
      });
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div>
      {ready ? (
        <>
          <Header />
          <div>
            <ToastContainer autoClose={2000} position="bottom-left" />

            <div className="container">
              <div className="row" style={{ marginTop: "120px" }}>
                <div
                  className="card"
                  style={{ padding: "20px", marginTop: "40px" }}
                >
                  {showPaybuttons ? (
                    <>
                      <div>
                        <div>
                          <div className="row">
                            <div className="col-md-6">
                              {/* <div className="row ">
                                <h4 style={{ fontWeight: "600" }}>
                                  Unlock Your Potential:
                                </h4>
                                <h4 style={{ fontWeight: "600" }}>
                                  Enroll Today!
                                </h4>
                                <p>
                                  Take the First Step Towards Your Bright Future
                                </p>
                                <img
                                  src="/images/enrolloneimg.png"
                                  alt="enrolimg"
                                  style={{ width: "100%", height: "241px" }}
                                />
                              </div> */}

                              <Popup
                                handleSubmit={handleAccessFormSubmit}
                                values={{
                                  name: formData.Name,
                                  email: formData.Email,
                                  phone: formData.Phone,
                                }}
                                errorMessage={errorMessage}
                              />
                            </div>
                            {/* onSubmit={SignIn} */}

                            <div className="col-md-6">
                              <div>
                                <div>
                                  {showOthers ? (
                                    <>
                                      <h3
                                        style={{
                                          marginTop: "30px",
                                          marginBottom: "40px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {pakagename}
                                      </h3>
                                      <div
                                        style={{
                                          backgroundColor: "#F5F5F5",
                                          borderRadius: "10px",
                                          width: "100%",
                                        }}
                                      >
                                        <div className="container">
                                          <div className="row">
                                            <div className="col-xl-6">
                                              <div
                                                className="text-center"
                                                style={{
                                                  backgroundColor: "#0b5a56",
                                                  borderRadius: "5px",
                                                  padding: "10px",
                                                  marginTop: "50px",
                                                }}
                                              >
                                                <h5
                                                  style={{
                                                    color: "#ffffff",
                                                    margin: "20px",
                                                  }}
                                                >
                                                  Payment
                                                </h5>
                                                <div
                                                  style={{
                                                    margin: "30px",
                                                    marginTop: "10px",
                                                  }}
                                                >
                                                  <h3
                                                    style={{ color: "#FFFFFF" }}
                                                  >
                                                    {currency}
                                                    {params["ids"] ===
                                                    "basicaccess"
                                                      ? prices.Basic
                                                      : params["ids"] ===
                                                        "intermediateaccess"
                                                      ? prices.Intermediate
                                                      : params["ids"] ===
                                                        "professionalaccess"
                                                      ? prices.Professional
                                                      : ""}
                                                  </h3>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-xl-6">
                                              <div
                                                style={{
                                                  marginTop: "30px",
                                                  marginBottom: "30px",
                                                }}
                                              >
                                                <h4>Select Payment Method</h4>
                                                <div
                                                  style={{
                                                    background: "#277a8f",
                                                    padding: "9px",
                                                    borderRadius: "10px",
                                                    cursor: "pointer",
                                                    textAlign: "center",
                                                    marginTop: "10px",
                                                    color: "#ffffff",
                                                    fontSize: "17px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                  }}
                                                  onClick={makepayment}
                                                >
                                                  Pay Now with
                                                  <img
                                                    src="/images/Stripepay.png"
                                                    alt="stripe"
                                                    style={{
                                                      marginLeft: "10px",
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <h5 style={{ textAlign: "center" }}>
                        Kindly fill to have access to our {pakagename} package
                      </h5>
                      <hr />
                      <form onSubmit={handleSubmit(submitWebinarform)}>
                        <div className="form-row">
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationName">
                                Name<span style={{ color: "#FF0000" }}>*</span>
                              </label>
                              <input
                                {...register("Name")}
                                type="text"
                                className={
                                  errors.Name
                                    ? "form-control is-invalid"
                                    : "form-control is-valid"
                                }
                                value={inputName}
                                onChange={(e) => setInputName(e.target.value)}
                                id="validationName"
                                placeholder="Your names (both your firstname and lastname)"
                              />
                              {errors.Name && (
                                <p className="errortext">
                                  {errors.Name.message}
                                </p>
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationEmail">
                                E-mail Address
                                <span style={{ color: "#FF0000" }}>*</span>
                              </label>
                              <input
                                {...register("Email")}
                                type="email"
                                className={
                                  errors.Email
                                    ? "form-control is-invalid"
                                    : "form-control is-valid"
                                }
                                value={inputEmail}
                                onChange={(e) => setInputEmail(e.target.value)}
                                id="validationEmail"
                                placeholder="Your email"
                              />
                              {errors.Email && (
                                <p className="errortext">
                                  {errors.Email.message}
                                </p>
                              )}
                            </div>

                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationPhone">
                                Phone Number
                                <span style={{ color: "#FF0000" }}>*</span>
                              </label>

                              <div
                                className={
                                  nophoneerror
                                    ? "textinputspwebinar"
                                    : "textinputs2pwebinar"
                                }
                              >
                                <PhoneInput
                                  country={"ng"}
                                  inputStyle={{ width: "90%" }}
                                  value={inputPhone}
                                  onChange={(inputPhone) =>
                                    setInputPhone(inputPhone)
                                  }
                                  isValid={(value, country: any) => {
                                    /* eslint-disable no-useless-escape */
                                    if (
                                      value.match(
                                        /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/
                                      )
                                    ) {
                                      return (
                                        "Invalid value: " +
                                        value +
                                        ", " +
                                        country.name
                                      );
                                      /* eslint-disable no-useless-escape */
                                    } else if (
                                      value.match(
                                        /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/
                                      )
                                    ) {
                                      return false;
                                    } else {
                                      return true;
                                    }
                                  }}
                                />
                              </div>
                              {nophoneerror ? (
                                <></>
                              ) : (
                                <>
                                  <p
                                    className={
                                      nophoneerror ? "errortext3" : "errortext2"
                                    }
                                  >
                                    something Wrong with the Phone Number
                                  </p>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationDegree">
                                Educational Background
                                <span style={{ color: "#FF0000" }}>*</span>
                              </label>
                              <input
                                {...register("Degree")}
                                type="text"
                                className={
                                  errors.Degree
                                    ? "form-control is-invalid"
                                    : "form-control is-valid"
                                }
                                value={inputDegree}
                                onChange={(e) => setInputDegree(e.target.value)}
                                id="validationDegree"
                                placeholder="Current Level of Education, Field of Study, Any Relevant Certifications"
                              />
                              {errors.Degree && (
                                <p className="errortext">
                                  {errors.Degree.message}
                                </p>
                              )}
                            </div>

                            <div className="col-md-4 mb-3">
                              {showNysc ? (
                                <>
                                  <label htmlFor="validationNysc">
                                    NYSC call-up number
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control is-valid"
                                    value={inputNyscCN}
                                    onChange={(e) =>
                                      setInputNyscCN(e.target.value)
                                    }
                                    id="validationNysc"
                                    placeholder="your NYSC call-up number"
                                  />
                                  <div>
                                    <input
                                      type="checkbox"
                                      checked={showNysc}
                                      onClick={subscribeNysc}
                                    />{" "}
                                    <span>UnTick if None</span>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div style={{ marginTop: "10px" }}>
                                    <input
                                      type="checkbox"
                                      checked={showNysc}
                                      onClick={subscribeNysc}
                                    />{" "}
                                    <span>
                                      Tick if you have Nigeria NYSC call-off
                                      Number
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>

                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationServerExp">
                                Years of Experience in Tech
                                <span style={{ color: "#FF0000" }}>*</span>
                              </label>
                              <div style={{ marginTop: "10px" }}>
                                <input
                                  id="0"
                                  type="radio"
                                  name="codingexp"
                                  onClick={() => {
                                    setInputYearsofExp("0");
                                  }}
                                />
                                <span style={{ marginLeft: "10px" }}>0</span>
                                <br />
                              </div>

                              <div style={{ marginTop: "10px" }}>
                                <input
                                  id="1to3"
                                  type="radio"
                                  name="codingexp"
                                  onClick={() => {
                                    setInputYearsofExp("1-3");
                                  }}
                                />
                                <span style={{ marginLeft: "10px" }}>1-3</span>
                                <br />
                              </div>

                              <div style={{ marginTop: "10px" }}>
                                <input
                                  id="4above"
                                  type="radio"
                                  name="codingexp"
                                  onClick={() => {
                                    setInputYearsofExp("4 and above");
                                  }}
                                />
                                <span style={{ marginLeft: "10px" }}>
                                  4 and above
                                </span>
                                <br />
                              </div>
                              {errorYearsofExp ? (
                                <>
                                  <p className="errortext">No Value Chosen</p>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                            {/* <div className="col-md-4 mb-3">
                                                    <label htmlFor="validationServer02">E-mail Address<span style={{color: "#FF0000"}}>*</span></label>
                                                    <input  type="email" className="form-control is-valid" id="validationServer02" placeholder="Your email"  />
                                                        
                                                </div> */}
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationFieldofstudy">
                                Field of Study
                                <span style={{ color: "#FF0000" }}>*</span>
                              </label>
                              <div className="input-group">
                                <input
                                  {...register("FieldofStudy")}
                                  type="text"
                                  className={
                                    errors.FieldofStudy
                                      ? "form-control is-invalid"
                                      : "form-control is-valid"
                                  }
                                  value={inputFieldofStudy}
                                  onChange={(e) =>
                                    setInputFieldofStudy(e.target.value)
                                  }
                                  id="validationFieldofstudy"
                                  placeholder="Your Field of Study"
                                />
                                {errors.FieldofStudy && (
                                  <p className="errortext">
                                    {errors.FieldofStudy.message}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationTargetment">
                                What specific areas of tech are you looking for
                                mentorship in?
                                <span style={{ color: "#FF0000" }}>*</span>
                              </label>
                              <div className="input-group">
                                <input
                                  {...register("TargetofMent")}
                                  type="text"
                                  className={
                                    errors.TargetofMent
                                      ? "form-control is-invalid"
                                      : "form-control is-valid"
                                  }
                                  value={inputTargetofMent}
                                  onChange={(e) =>
                                    setInputTargetofMent(e.target.value)
                                  }
                                  id="validationTargetment"
                                  placeholder="Your Answer"
                                />
                                {errors.TargetofMent && (
                                  <p className="errortext">
                                    {errors.TargetofMent.message}
                                  </p>
                                )}
                              </div>
                            </div>

                            {/* <div className="col-md-4 mb-3">
                                                    <label htmlFor="validationServer03">What specific areas of tech are you looking for mentorship in?<span style={{color: "#FF0000"}}>*</span></label>
                                                    <div style={{marginTop: "10px"}}>
                                                        <input  id="software"  type="radio" name="coding"/><span style={{marginLeft: "10px"}}>Yes</span><br/>
                                                    </div>
                                                    
                                                    <div style={{marginTop: "10px"}}>
                                                        <input id="software" type="radio" name="coding" /><span style={{marginLeft: "10px"}}>No</span><br/>
                                                    
                                                    </div>
                                                </div> */}

                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationTransition">
                                Are you looking to transition into a new role or
                                level up in your current role?
                                <span style={{ color: "#FF0000" }}>*</span>
                              </label>
                              <div className="input-group">
                                <input
                                  {...register("Transition")}
                                  type="text"
                                  className={
                                    errors.Transition
                                      ? "form-control is-invalid"
                                      : "form-control is-valid"
                                  }
                                  value={inputTransition}
                                  onChange={(e) =>
                                    setInputTransition(e.target.value)
                                  }
                                  id="validationTransition"
                                  placeholder="Your Answer"
                                />
                                {errors.Transition && (
                                  <p className="errortext">
                                    {errors.Transition.message}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationCommunication">
                                Preferred Communication Channel
                                <span style={{ color: "#FF0000" }}>*</span>
                              </label>
                              <div style={{ marginTop: "10px" }}>
                                <input
                                  id="videocall"
                                  type="radio"
                                  name="communication"
                                  onClick={() => {
                                    setInputCommunication("Video Call");
                                  }}
                                />
                                <span style={{ marginLeft: "10px" }}>
                                  Video Call
                                </span>
                                <br />
                              </div>

                              <div style={{ marginTop: "10px" }}>
                                <input
                                  id="voicecall"
                                  type="radio"
                                  name="communication"
                                  onClick={() => {
                                    setInputCommunication("Voice Call");
                                  }}
                                />
                                <span style={{ marginLeft: "10px" }}>
                                  Voice Call
                                </span>
                                <br />
                              </div>

                              <div style={{ marginTop: "10px" }}>
                                <input
                                  id="texts"
                                  type="radio"
                                  name="communication"
                                  onClick={() => {
                                    setInputCommunication("Texts");
                                  }}
                                />
                                <span style={{ marginLeft: "10px" }}>
                                  Texts
                                </span>
                                <br />
                              </div>
                              {errorCommunication ? (
                                <>
                                  <p className="errortext">No Value Chosen</p>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>

                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationFrequency">
                                Frequency of Mentorship Sessions
                                <span style={{ color: "#FF0000" }}>*</span>
                              </label>
                              <div style={{ marginTop: "10px" }}>
                                <input
                                  id="weekly"
                                  type="radio"
                                  name="mentorship"
                                  onClick={() => {
                                    setInputFrequency("Weekly");
                                  }}
                                />
                                <span style={{ marginLeft: "10px" }}>
                                  Weekly
                                </span>
                                <br />
                              </div>

                              <div style={{ marginTop: "10px" }}>
                                <input
                                  id="biweekly"
                                  type="radio"
                                  name="mentorship"
                                  onClick={() => {
                                    setInputFrequency("Bi-weekly");
                                  }}
                                />
                                <span style={{ marginLeft: "10px" }}>
                                  Bi-weekly
                                </span>
                                <br />
                              </div>

                              <div style={{ marginTop: "10px" }}>
                                <input
                                  id="monthly"
                                  type="radio"
                                  name="mentorship"
                                  onClick={() => {
                                    setInputFrequency("Monthly");
                                  }}
                                />
                                <span style={{ marginLeft: "10px" }}>
                                  Monthly
                                </span>
                                <br />
                              </div>
                              {errorFrequency ? (
                                <>
                                  <p className="errortext">No Value Chosen</p>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>

                            <div className="col-md-4 mb-3">
                              <label htmlFor="validationGoal">
                                What do you hope to achieve through this
                                mentorship program?
                                <span style={{ color: "#FF0000" }}>*</span>
                              </label>
                              <div className="input-group">
                                <input
                                  {...register("Goal")}
                                  type="text"
                                  className={
                                    errors.Goal
                                      ? "form-control is-invalid"
                                      : "form-control is-valid"
                                  }
                                  value={inputGoal}
                                  onChange={(e) => setInputGoal(e.target.value)}
                                  id="validationGoal"
                                  placeholder="Your Answer"
                                />
                                {errors.Goal && (
                                  <p className="errortext">
                                    {errors.Goal.message}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <hr />
                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label htmlFor="validationRequest">
                              Any specific challenges or questions you'd like
                              guidance on?
                              <span style={{ color: "#FF0000" }}>*</span>
                            </label>
                            <div className="input-group">
                              <input
                                {...register("Request")}
                                type="text"
                                className={
                                  errors.Request
                                    ? "form-control is-invalid"
                                    : "form-control is-valid"
                                }
                                value={inputRequest}
                                onChange={(e) =>
                                  setInputRequest(e.target.value)
                                }
                                id="validationRequest"
                                placeholder="Your Answer"
                              />
                              {errors.Request && (
                                <p className="errortext">
                                  {errors.Request.message}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-4 mb-3">
                            <label htmlFor="validationMedium">
                              How Did You Hear About Access Doyenify Program?
                              <span style={{ color: "#FF0000" }}>*</span>
                            </label>
                            <div style={{ marginTop: "10px" }}>
                              <input
                                id="socialmedia"
                                type="radio"
                                name="medium"
                                onClick={() => {
                                  setInputMedium("Social Media");
                                }}
                              />
                              <span style={{ marginLeft: "10px" }}>
                                Social Media
                              </span>
                              <br />
                            </div>

                            <div style={{ marginTop: "10px" }}>
                              <input
                                id="referral"
                                type="radio"
                                name="medium"
                                onClick={() => {
                                  setInputMedium("Referral");
                                }}
                              />
                              <span style={{ marginLeft: "10px" }}>
                                Referral
                              </span>
                              <br />
                            </div>

                            <div style={{ marginTop: "10px" }}>
                              <input
                                id="website"
                                type="radio"
                                name="medium"
                                onClick={() => {
                                  setInputMedium("Website");
                                }}
                              />
                              <span style={{ marginLeft: "10px" }}>
                                Website
                              </span>
                              <br />
                            </div>

                            <div style={{ marginTop: "10px" }}>
                              <input
                                id="other"
                                type="radio"
                                name="medium"
                                onClick={() => {
                                  setInputMedium("Others");
                                }}
                              />
                              <span style={{ marginLeft: "10px" }}>
                                Others (please specify)
                              </span>
                              <br />
                            </div>
                            {errorMedium ? (
                              <>
                                <p className="errortext">No Value Chosen</p>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>

                          <div className="col-md-4 mb-3">
                            <label htmlFor="validationCountry">
                              Country<span style={{ color: "#FF0000" }}>*</span>
                            </label>

                            <Select
                              options={options}
                              value={valueCountry}
                              onChange={changeHandler}
                            />
                            {errorCountry ? (
                              <>
                                <p className="errortext">No Value Chosen</p>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>

                          <div className="col-md-4 mb-3">
                            <label htmlFor="validationComment">
                              Any Additional Comments or Questions
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control is-valid"
                                value={inputComment}
                                onChange={(e) =>
                                  setInputComment(e.target.value)
                                }
                                id="validationComment"
                                placeholder="Your Answer"
                              />
                            </div>
                          </div>
                        </div>

                        <button type="submit" className="btn btn-success">
                          Submit form
                        </button>
                      </form>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <br />
          <br />
          <br />

          <Footer />
        </>
      ) : (
        <>
          <div>
            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DoyenaccessDetails;
